var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckIn = function SvgCheckIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 25.7H9.2c-1.4 0-2.6-1.2-2.6-2.6V8.9c0-1.4 1.2-2.6 2.6-2.6h4.4c1.1 0 1.9-.9 1.9-1.9s-.9-1.9-1.9-1.9H9.2C5.6 2.5 2.7 5.4 2.7 9v14.2c0 3.6 2.9 6.5 6.5 6.5h4.4c1.1 0 1.9-.9 1.9-1.9s-.8-2.1-1.9-2.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.9 17.5 6.9 6.9c.5.5 1.2.7 1.9.5s1.2-.7 1.4-1.4 0-1.4-.5-1.9l-3.5-3.5h8.3c1 0 1.9-.9 1.9-1.9s-.8-1.9-1.9-1.9h-8.6l3.8-3.8c.5-.5.7-1.2.5-1.9s-.7-1.2-1.4-1.4c-.2 0-.3-.1-.5-.1-.5 0-1 .2-1.4.6l-6.9 6.9c-.8.9-.8 2.1 0 2.9"
  })));
};
export default SvgCheckIn;